module.exports = __webpack_public_path__ + "assets/icon_mango_highlight.68862f42.svg";